import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'next-themes';
import { AuthProvider } from './contexts/AuthContext';
import { PlanProvider } from './contexts/PlanContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminLayout from './components/AdminLayout';
import TenantLayout from './components/TenantLayout';
import Dashboard from './pages/admin/Dashboard';
import Tenants from './pages/admin/Tenants';
import TenantDetail from './pages/admin/TenantDetail';
import WaitlistPage from './pages/admin/WaitlistPage';
import Settings from './pages/admin/Settings';
import Backups from './pages/admin/Backups';
import Monitoring from './pages/admin/Monitoring';
import EmailTemplates from './pages/admin/EmailTemplates';
import EmailLog from './pages/admin/EmailLog';
import Announcements from './pages/admin/Announcements';
import Backgrounds from './pages/admin/Backgrounds';
import AiUsage from './pages/admin/AiUsage';
import ProvisionWizard from './pages/admin/ProvisionWizard';
import UsersPage from './pages/admin/UsersPage';
import TenantHome from './pages/tenant/TenantHome';
import TenantSites from './pages/tenant/TenantSites';
import TenantBackups from './pages/tenant/TenantBackups';
import TenantAccount from './pages/tenant/TenantAccount';
import TenantBilling from './pages/tenant/TenantBilling';
import TenantSecurity from './pages/tenant/TenantSecurity';
import ProtectedRoute from './components/ProtectedRoute';

export default function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
    <AuthProvider>
    <PlanProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/waitlist" element={<Navigate to="/register" replace />} />

          {/* Tenant dashboard (authenticated users) */}
          <Route path="/dashboard" element={
            <ProtectedRoute><TenantLayout /></ProtectedRoute>
          }>
            <Route index element={<TenantHome />} />
            <Route path="sites" element={<TenantSites />} />
            <Route path="backups" element={<TenantBackups />} />
            <Route path="billing" element={<TenantBilling />} />
            <Route path="account" element={<TenantAccount />} />
            <Route path="security" element={<TenantSecurity />} />
          </Route>

          {/* Super admin panel */}
          <Route path="/admin" element={
            <ProtectedRoute requiredRole="super_admin"><AdminLayout /></ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="tenants" element={<Tenants />} />
            <Route path="tenants/:id" element={<TenantDetail />} />
            <Route path="waitlist" element={<WaitlistPage />} />
            <Route path="provision" element={<ProvisionWizard />} />
            <Route path="provision/:userId" element={<ProvisionWizard />} />
            <Route path="backups" element={<Backups />} />
            <Route path="monitoring" element={<Monitoring />} />
            <Route path="ai-usage" element={<AiUsage />} />
            <Route path="email-templates" element={<EmailTemplates />} />
            <Route path="email-log" element={<EmailLog />} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="backgrounds" element={<Backgrounds />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="security" element={<TenantSecurity />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </PlanProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}
